import { request } from "@/service/request";
import { HttpResponse } from "@/service/common/entity/HttpResponse";
import { ewodHost } from "@/config/host";
/**
 * 登录
 * @returns
 */
export function login(data: {
  user_name: string;
  password: string;
}): Promise<HttpResponse<any>> {
  return request({
    url: `${ewodHost}/user/login`,
    method: "post",
    data,
    withCredentials: true,
  });
}

/**
 * 获取token
 * @returns
 */
export function getToken(): Promise<HttpResponse<string>> {
  return request({
    url: `${ewodHost}/user/getToken`,
    method: "get",
    withCredentials: true,
  });
}
